import React, { useEffect, useState } from 'react';
import styles from './ChatActionToast.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { useTranslation } from 'react-i18next';

interface ChatActionToastProps {
  payload: {
    title: string;
    body: string;
  } | null;
  onClose: () => void;
}

export const ChatActionToast: React.FC<ChatActionToastProps> = ({ payload, onClose }) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (payload) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        setTimeout(() => onClose(), 300); // Wait for transition before fully unmounting/closing
      }, 8000); // 8 seconds display time
      return () => clearTimeout(timer);
    }
  }, [payload, onClose]);

  if (!payload) return null;

  return (
    <div className={`${styles['toast']} ${show ? styles['toast--show'] : ''}`}>
      <div className={styles['toast__icon']}>
        <NotificationsActiveIcon />
      </div>
      <div className={styles['toast__content']}>
        <h4 className={styles['toast__title']}>{payload.title}</h4>
        <p className={styles['toast__body']}>{payload.body}</p>
      </div>
      <button 
        className={styles['toast__close']} 
        onClick={() => {
            setShow(false);
            setTimeout(() => onClose(), 300);
        }}
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
};
